module.exports = __webpack_public_path__ + "img/Checkbox unselected Icon - white.c891ed5c.svg";